import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  searchData: "",
  restaurantsList: [],
  restaurantsStatus: { value: "ALL", label: "All" },
  restaurantRowsPerPage: 10,
};

const restaurantSearchSlice = createSlice({
  name: "restaurants",
  initialState,
  reducers: {
    setSearchData(state, action) {
      state.searchData = action.payload;
    },
    setRestaurantsList(state, action) {
      state.restaurantsList = action.payload;
    },
    setRestaurantsStatus(state, action) {
      state.restaurantsStatus = action.payload;
    },
    setRestaurantRowsPerPage(state, action) {
      state.restaurantRowsPerPage = action.payload;
    },
    clearRestaurantsRowsPerPage(state) {
      state.restaurantRowsPerPage = 10;
    },
  },
});

export const { setSearchData, setRestaurantsList, setRestaurantsStatus, setRestaurantRowsPerPage, clearRestaurantsRowsPerPage } =
  restaurantSearchSlice.actions;
export default restaurantSearchSlice.reducer;
